(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["awokee-catalog-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('awokee-service-filter')) {
  class AwokeeServiceFilter extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = Array.from(this.querySelectorAll('[data-aw-service]'));
      this.cards = Array.from(this.querySelectorAll('[data-aw-services]'));
      this.status = this.querySelector('[data-aw-filter-status]');
      this.querySelector('.aw-catalog-filters').hidden = false;
      this.apply = (value, updateUrl = false) => {
        const active = this.buttons.find(b => b.dataset.awService === value) || this.buttons[0];
        const key = active.dataset.awService;
        this.buttons.forEach(b => b.setAttribute('aria-pressed', String(b === active)));
        this.cards.forEach(card => { card.hidden = key !== 'all' && !card.dataset.awServices.trim().split(/\s+/).includes(key); });
        const count = this.cards.filter(card => !card.hidden).length;
        this.status.textContent = this.status.dataset.format.replace('[count]', count).replace('[setting]', active.textContent.trim());
        if (updateUrl) { const url = new URL(location.href); key === 'all' ? url.searchParams.delete('service') : url.searchParams.set('service', key); history.replaceState(history.state, '', url); }
      };
      this.onClick = event => { const button = event.target.closest('[data-aw-service]'); if(button && this.contains(button)) this.apply(button.dataset.awService, true); };
      this.onPop = () => this.apply(new URLSearchParams(location.search).get('service'));
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPop);
      this.onPop();
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); window.removeEventListener('popstate', this.onPop); this.ready = false; }
  }
  customElements.define('awokee-service-filter', AwokeeServiceFilter);
}
  } catch(e) { console.error(e); }
})();

})();
